import { createFileRoute } from "@tanstack/react-router";
import React from "react";

import { CheckboxGroupField } from "~/components/form/checkbox-group-field";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import {
  CoachExperienceLevelSchema,
  coachPackagesStep,
  coachingPackagesField,
} from "~/lib/schemas/coach-discovery";
import type { CoachExperienceLevelForm } from "~/lib/schemas/coach-discovery";
import { createNoIndexMeta } from "~/lib/shared/meta";

export const Route = createFileRoute("/_public/discovery/steps/4/")({
  head: () =>
    createNoIndexMeta(
      "Step 4: Coaching Packages & Experience – Dream Coach Match",
      "Define your coaching package preferences in our discovery process",
    ),
  component: DiscoveryStep4,
});

function DiscoveryStep4() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm({
    step: 4,
    schema: CoachExperienceLevelSchema,
  });
  const { handleSubmit, control, formState } = form;
  const { errors, isSubmitting, isValid } = formState;

  const onSubmit = (_data: CoachExperienceLevelForm) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={coachPackagesStep.title} />
      <DiscoveryStep.SubTitle title={coachingPackagesField.subTitle} />
      <DiscoveryStep.Card className="mt-6">
        <FormField error={errors.coachingPackages?.message}>
          <CheckboxGroupField
            name="coachingPackages"
            control={control}
            options={coachingPackagesField.options || []}
            exclusiveOptions={["No preference"]}
          />
        </FormField>
      </DiscoveryStep.Card>
      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        loading={isSubmitting}
        disabled={!isValid}
      />
    </form>
  );
}
